import { render } from "./LokomotivView.vue?vue&type=template&id=6ca00dd8"
import script from "./LokomotivView.vue?vue&type=script&lang=js"
export * from "./LokomotivView.vue?vue&type=script&lang=js"

import "./LokomotivView.vue?vue&type=style&index=0&id=6ca00dd8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__